import qcJobsStatuses from '@pluto/qc-jobs-statuses/Redux/QCJobsStatusesReducer';
import qcReportsReasons from '@pluto/qc-reports/qc-reports-reasons/Redux/QCReportsReasonsReducer';
import qcReportsNotes from '@pluto/qc-reports/qc-reports-notes/Redux/QCReportsNotesReducer';
import {combineReducers} from 'redux';

const qcJobsStore = combineReducers({
    qcJobsStatuses,
    qcReportsReasons,
    qcReportsNotes,
});

export default qcJobsStore;
